import { useEffect, useState } from "react";

const DEBOUNCE_MS = 300;

const HIDDEN_SCROLLBAR_SX = {
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
} as const;

/**
 * Returns an `sx` object spread that hides the scrollbar while the given
 * `value` is actively changing (debounced by DEBOUNCE_MS).
 */
export const useScrollbarDebounce = (
  value: unknown,
): Record<string, never> | typeof HIDDEN_SCROLLBAR_SX => {
  const [isDebouncing, setIsDebouncing] = useState(false);

  useEffect(() => {
    setIsDebouncing(true);
    const id = setTimeout(() => setIsDebouncing(false), DEBOUNCE_MS);

    return () => clearTimeout(id);
  }, [value]);

  return isDebouncing ? HIDDEN_SCROLLBAR_SX : {};
};
